module.exports = __webpack_public_path__ + "static/media/ffo_gutefee.91c02291.jpg";